import { LogsFront } from './LogsFront'
import { Helper } from '../../../../classes/helper'
import { useMontage } from '../../../../context/montage.context'

export const LogsBack = (): JSX.Element | null => {
  const { measure, roof } = useMontage()

  if (roof.attachment !== 'Freistehend') return null

  return (
    <group position={[0, 0, Helper.convertToMeter(-measure.userDepth)]}>
      <LogsFront isBackLog={true} />
    </group>
  )
}
